/**
 * Single source of the footer destinations.
 *
 * The same set is rendered in three places — the full footer shown to guests, the slim
 * strip shown to signed-in users, and the "About" screen in the native app — so keeping
 * the URLs here stops them drifting apart. Labels stay at the call site: each surface
 * words them differently and Lingui macros have to run inside a component.
 *
 * Route paths carry the `{-$locale}` prefix expected by the typed router links.
 */
export const FOOTER_ROUTES = {
  blog: '/{-$locale}/blog',
  faq: '/{-$locale}/faq',
  discordBot: '/{-$locale}/discord-lfg-bot',
  joinTheTeam: '/{-$locale}/build-with-us',
  partnerWithUs: '/{-$locale}/partner-with-us',
  terms: '/{-$locale}/terms-and-conditions',
  privacy: '/{-$locale}/privacy-policy',
} as const;

/**
 * Same page as FOOTER_ROUTES.discordBot, without the router prefix — for building an
 * absolute URL when the page is opened outside the app rather than navigated to.
 */
export const DISCORD_BOT_PATH = '/discord-lfg-bot';

export const FOOTER_CONTACT_EMAIL = 'hello@teamplay.gg';

export const FOOTER_SOCIALS = {
  discord: 'https://discord.gg/gt56cQ4nWb',
  x: 'https://x.com/teamplay_gg',
} as const;
